import { Link, Outlet, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { ROUTES } from "@/config/constants";

function secaoAtual(pathname: string): string | null {
  if (pathname.startsWith(ROUTES.GENTE_GESTAO_DESLIGAMENTO)) return "Entrevista de desligamento";
  if (pathname.startsWith(ROUTES.GENTE_GESTAO_ESCUTA)) return "Escuta Ativa";
  if (pathname.startsWith(ROUTES.GENTE_GESTAO_LIDERANCA)) return "Avaliação de Liderança";
  if (pathname.startsWith(ROUTES.GENTE_GESTAO_NPS)) return "Pesquisas eNPS";
  if (pathname.startsWith(ROUTES.GENTE_GESTAO_COLABORADORES)) return "Colaboradores";
  if (pathname.startsWith(ROUTES.GENTE_GESTAO_VISAO)) return "Visão geral";
  return null;
}

export function GenteGestaoLayout() {
  const { pathname } = useLocation();
  const noMenu = pathname === ROUTES.GENTE_GESTAO;
  const secao = secaoAtual(pathname);

  if (noMenu) {
    return (
      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4">
      <div className="flex items-center gap-2">
        <Link
          to={ROUTES.GENTE_GESTAO}
          className="inline-flex items-center gap-1 text-sm font-medium text-brand-700 hover:text-brand-800"
        >
          <ChevronLeft className="h-4 w-4" />
          Gente & Gestão
        </Link>
        {secao && <span className="text-sm text-slate-400">/ {secao}</span>}
      </div>
      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>
  );
}
